// Notbremse gegen haengende Scroll-Sperren.
//
// Das DIRS21-Buchungsfenster sperrt beim Oeffnen im Vollbild das Scrollen der
// Seite dahinter (uebliche Technik: overflow:hidden bzw. position:fixed auf
// <body>). Beim Schliessen gibt es die Sperre nicht zuverlaessig wieder frei -
// die Seite bleibt dann unscrollbar, bis man neu laedt.
//
// Im eigenen Code wird das Scrollen an keiner Stelle gesperrt. Alles, was diese
// Funktion zuruecksetzt, stammt also von aussen und darf weg.
export function releaseScrollLock() {
  if (typeof document === 'undefined') return;

  for (const el of [document.body, document.documentElement]) {
    if (!el) continue;
    const s = el.style;

    // Bei der position:fixed-Variante merkt sich die Sperre die Scrollposition
    // in style.top (negativer Wert). Die stellen wir wieder her.
    let restoreY: number | null = null;
    if (s.position === 'fixed') {
      const top = parseInt(s.top || '0', 10);
      if (!Number.isNaN(top) && top < 0) restoreY = -top;
      s.position = '';
      s.top = '';
      s.left = '';
      s.right = '';
      s.width = '';
    }

    if (s.overflow === 'hidden') s.overflow = '';
    if (s.overflowY === 'hidden') s.overflowY = '';
    if (s.paddingRight) s.paddingRight = '';

    if (restoreY !== null) window.scrollTo({ top: restoreY, behavior: 'instant' as ScrollBehavior });
  }
}

// Prueft, ob gerade eine Sperre aktiv ist - ohne etwas zu veraendern.
export function isScrollLocked(): boolean {
  if (typeof document === 'undefined') return false;
  return [document.body, document.documentElement].some((el) => {
    if (!el) return false;
    const s = el.style;
    return s.overflow === 'hidden' || s.overflowY === 'hidden' || s.position === 'fixed';
  });
}
